import { render, staticRenderFns } from "./DataTableFutures.vue?vue&type=template&id=eb48e8d4&scoped=true"
import script from "./DataTableFutures.vue?vue&type=script&lang=js"
export * from "./DataTableFutures.vue?vue&type=script&lang=js"
import style0 from "./DataTableFutures.vue?vue&type=style&index=0&id=eb48e8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb48e8d4",
  null
  
)

export default component.exports